<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="dedi"><a id="page_9"></a>To Steve, Joshua, &amp; Owen—my boys with the biggest hearts with the greatest abundance for love who fill my bucket every day.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Dedication.vue?704a9577